import { defineMessages } from 'react-intl';

export default defineMessages({
    CoverageChangesHeader: {
        id: 'cep.components.sgEndorsementQuotePage.CoverageChangesHeader',
        defaultMessage: 'Your cover options'
    },
    CoverageAdded: {
        id: 'cep.components.sgEndorsementQuotePage.CoverageAdded',
        defaultMessage: 'Added: {coverage}'
    },
    CoverageRemoved: {
        id: 'cep.components.sgEndorsementQuotePage.CoverageRemoved',
        defaultMessage: 'Removed: {coverage}'
    },
    Changed: {
        id: 'cep.components.sgEndorsementQuotePage.Changed',
        defaultMessage: 'Changed:'
    },
    BreakdownCoverChanged: {
        id: 'cep.components.sgEndorsementQuotePage.BreakdownCoverChanged',
        defaultMessage: 'Saga Breakdown Assistance - level of cover changed to {coverLevel}'
    },
    VoluntaryExcessChanged: {
        id: 'cep.components.sgEndorsementQuotePage.VoluntaryExcessChanged',
        defaultMessage: 'Voluntary Accidental Damage Excess changed to {excess}'
    },
    PNCDPriceChanged: {
        id: 'cep.components.sgEndorsementQuotePage.PNCDPriceChanged',
        defaultMessage: 'Price has changed for PNCD to £{amount}'
    }
});
